import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const withAuth = () => {
    const token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// ===== Tarif Pembayaran =====
export const getTarif = createAsyncThunk("pembayaranConfig/getTarif", async () => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/tarif-pembayaran`);
    return response.data;
});
export const saveTarif = createAsyncThunk("pembayaranConfig/saveTarif", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.post(`v1/tarif-pembayaran`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});
export const updateTarif = createAsyncThunk("pembayaranConfig/updateTarif", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.put(`v1/tarif-pembayaran`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});
export const deleteTarif = createAsyncThunk("pembayaranConfig/deleteTarif", async (id) => {
    withAuth();
    const response = await jwtAuthAxios.delete(`v1/tarif-pembayaran/${id}`);
    return response.data;
});

// ===== Konfigurasi Cicilan =====
export const getCicilan = createAsyncThunk("pembayaranConfig/getCicilan", async () => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/cicilan-config`);
    return response.data;
});
export const saveCicilan = createAsyncThunk("pembayaranConfig/saveCicilan", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.post(`v1/cicilan-config`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});
export const updateCicilan = createAsyncThunk("pembayaranConfig/updateCicilan", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.put(`v1/cicilan-config`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});
export const deleteCicilan = createAsyncThunk("pembayaranConfig/deleteCicilan", async (id) => {
    withAuth();
    const response = await jwtAuthAxios.delete(`v1/cicilan-config/${id}`);
    return response.data;
});

const initialState = {
    loadingTarif: false,
    dataTarif: [],
    loadingCicilan: false,
    dataCicilan: [],
    saving: false,
};

const pembayaranConfigSlice = createSlice({
    name: "pembayaranConfig",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTarif.pending, (state) => { state.loadingTarif = true; })
            .addCase(getTarif.fulfilled, (state, action) => {
                state.dataTarif = Array.isArray(action.payload) ? action.payload : [];
                state.loadingTarif = false;
            })
            .addCase(getTarif.rejected, (state) => { state.loadingTarif = false; });

        builder
            .addCase(getCicilan.pending, (state) => { state.loadingCicilan = true; })
            .addCase(getCicilan.fulfilled, (state, action) => {
                state.dataCicilan = Array.isArray(action.payload) ? action.payload : [];
                state.loadingCicilan = false;
            })
            .addCase(getCicilan.rejected, (state) => { state.loadingCicilan = false; });

        // status saving untuk semua mutasi
        [saveTarif, updateTarif, saveCicilan, updateCicilan].forEach((thunk) => {
            builder
                .addCase(thunk.pending, (state) => { state.saving = true; })
                .addCase(thunk.fulfilled, (state) => { state.saving = false; })
                .addCase(thunk.rejected, (state) => { state.saving = false; });
        });
    },
});

export const pembayaranConfigSelector = (state) => state.pembayaranConfig;
export default pembayaranConfigSlice.reducer;
